const actionType = {
  UPDATE_FX_ACCOUNT_PASSSWORD: {
    id: 1,
    name: 'Update Password',
    displayName: 'Update Password',
  },
  RETRIEVE_PASSWORD: {
    id: 2,
    name: 'Retrieve Password',
    displayName: 'Retrieve Password',
  },
  ACTIVATE_FX_ACCOUNT: {
    id: 3,
    name: 'Activate FileX Account',
    displayName: 'Activate',
  },
  UPDATE_CONTACT: {
    id: 4,
    name: 'Update Contact',
    displayName: 'Update Contact',
  },
};

export default actionType;
